import { Component } from "react";
import { connect } from "react-redux";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CustomerModal from "../../Customers/CustomerModal";
import { customerSearch, clearCustomerSearch } from "../../../redux/tiers/tiersActions";
import CustomizedTextField from "../../Input/CustomizedTextField";
import CustomerIcon from "@mui/icons-material/AssignmentInd";
import Button from "@mui/material/Button";
import { formatStatus } from "../../../redux/siteMonitoring/siteMonitoringStatusActions";
import PhoneIcon from "@mui/icons-material/Phone";

class DetailsTab extends Component {
    constructor(props) {
        super(props);
        this.state = {
            customerModalOpenned: false,
        };

        if (
            this.props.siteMonitoring.delivery_partner_id &&
            this.props.siteMonitoring.delivery_partner_id.customer_code
        )
            this.props.customerSearch(
                this.props.siteMonitoring.delivery_partner_id.customer_code,
                this.props.activeUser
            );
        else this.props.clearCustomerSearch();
    }

    onCustomerClick() {
        if (this.props.customerFound)
            this.setState({
                customerModalOpenned: true,
            });
    }

    closeCustomer() {
        this.setState({
            customerModalOpenned: false,
        });
    }

    onPhoneNumberClick() {
        document.location.href = "tel:" + this.props.siteMonitoring.delivery_partner_id.phone;
    }

    onSiteManagerPhoneNumberClick() {
        document.location.href = "tel:" + this.props.siteMonitoring.site_manager_id.phone;
    }

    render() {
        let strCustomer = "";

        if (this.props.siteMonitoring.delivery_partner_id)
            strCustomer =
                this.props.siteMonitoring.delivery_partner_id.name +
                " [" +
                this.props.siteMonitoring.delivery_partner_id.id +
                "]";

        return (
            <Card className="col-lg-12 col-md-12 col-sm-12 col-12 card card-margin-top without-side-padding">
                <CardContent className="without-side-padding">
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12 row">
                            <div className="col-lg-10 col-md-10 col-sm-10 col-9 without-side-padding">
                                <CustomizedTextField
                                    value={strCustomer}
                                    id="customer"
                                    multiline
                                    label="Client"
                                    className="full_size light-disabled control-margin-top "
                                />
                            </div>
                            {this.props.customerFound ? (
                                <div className="without-side-padding col-lg-2 col-md-2 col-sm-2 col-3 control-inline-btn">
                                    <Button
                                        className="div-center"
                                        variant="contained"
                                        size="small"
                                        onClick={this.onCustomerClick.bind(this)}
                                    >
                                        <CustomerIcon />
                                    </Button>
                                </div>
                            ) : null}
                            <CustomerModal
                                onClose={this.closeCustomer.bind(this)}
                                modalOpenned={this.state.customerModalOpenned}
                            />
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12 row">
                            <div className="col-lg-10 col-md-10 col-sm-10 col-9 without-side-padding">
                                <CustomizedTextField
                                    value={
                                        this.props.siteMonitoring.delivery_partner_id
                                            ? this.props.siteMonitoring.delivery_partner_id.phone
                                            : ""
                                    }
                                    id="phone"
                                    label="Téléphone"
                                    className="full_size light-disabled control-margin-top"
                                />
                            </div>
                            {this.props.siteMonitoring.delivery_partner_id &&
                            this.props.siteMonitoring.delivery_partner_id.phone ? (
                                <div className="without-side-padding col-lg-2 col-md-2 col-sm-2 col-3 control-inline-btn">
                                    <Button
                                        className="div-center"
                                        variant="contained"
                                        size="small"
                                        onClick={this.onPhoneNumberClick.bind(this)}
                                    >
                                        <PhoneIcon />
                                    </Button>
                                </div>
                            ) : null}
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                            <CustomizedTextField
                                value={this.props.siteMonitoring.date_start.format("DD/MM/YYYY")}
                                id="date-start"
                                label="Date de début"
                                className="full_size light-disabled control-margin-top"
                            />
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                            <CustomizedTextField
                                value={this.props.siteMonitoring.date.format("DD/MM/YYYY")}
                                id="date-end"
                                label="Date de fin"
                                className="full_size light-disabled control-margin-top"
                            />
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                            <CustomizedTextField
                                value={this.props.siteMonitoring.name}
                                id="affair"
                                label="Affaire"
                                className="full_size light-disabled control-margin-top"
                            />
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                            <CustomizedTextField
                                value={formatStatus(this.props.siteMonitoring.state)}
                                id="state"
                                label="Statut"
                                className="full_size light-disabled control-margin-top"
                            />
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                            <CustomizedTextField
                                value={
                                    this.props.siteMonitoring.site_manager_id
                                        ? this.props.siteMonitoring.site_manager_id.name
                                        : ""
                                }
                                id="site-manager"
                                label="Chef de chantier"
                                className="full_size light-disabled control-margin-top"
                            />
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12 row">
                            <div className="col-lg-10 col-md-10 col-sm-10 col-9 without-side-padding">
                                <CustomizedTextField
                                    value={
                                        this.props.siteMonitoring.site_manager_id
                                            ? this.props.siteMonitoring.site_manager_id.phone
                                            : ""
                                    }
                                    id="phone-site-manager"
                                    label="Téléphone chef de chantier"
                                    className="full_size light-disabled control-margin-top "
                                />
                            </div>
                            {this.props.siteMonitoring.site_manager_id &&
                            this.props.siteMonitoring.site_manager_id.phone ? (
                                <div className="without-side-padding col-lg-2 col-md-2 col-sm-2 col-3 control-inline-btn">
                                    <Button
                                        className="div-center"
                                        variant="contained"
                                        size="small"
                                        onClick={this.onSiteManagerPhoneNumberClick.bind(this)}
                                    >
                                        <PhoneIcon />
                                    </Button>
                                </div>
                            ) : null}
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                            <CustomizedTextField
                                value={
                                    this.props.siteMonitoring.engineering_user_id
                                        ? this.props.siteMonitoring.engineering_user_id.name
                                        : ""
                                }
                                id="affair-manager"
                                label="Chargé d'affaire"
                                className="full_size light-disabled control-margin-top "
                            />
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                            <CustomizedTextField
                                value={
                                    this.props.siteMonitoring.business_user_id
                                        ? this.props.siteMonitoring.business_user_id.name
                                        : ""
                                }
                                id="business-manager"
                                label="Commercial"
                                className="full_size light-disabled control-margin-top "
                            />
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                            <CustomizedTextField
                                value={
                                    this.props.siteMonitoring.waranty_start_date
                                        ? this.props.siteMonitoring.waranty_start_date.format("DD/MM/YYYY")
                                        : ""
                                }
                                id="warranty-start"
                                label="Date de début de garantie"
                                className="full_size light-disabled control-margin-top"
                            />
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                            <CustomizedTextField
                                value={
                                    this.props.siteMonitoring.waranty_end_date
                                        ? this.props.siteMonitoring.waranty_end_date.format("DD/MM/YYYY")
                                        : ""
                                }
                                id="warranty-end"
                                label="Date de fin de garantie"
                                className="full_size light-disabled control-margin-top"
                            />
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                            <CustomizedTextField
                                value={this.props.siteMonitoring.warranty_period}
                                id="warranty-period"
                                label="Durée de garantie (mois)"
                                className="full_size light-disabled control-margin-top "
                            />
                        </div>
                    </div>
                </CardContent>
            </Card>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        siteMonitoring: state.siteMonitoring.currentSiteMonitoring,
        activeUser: state.activeUser,
        customerFound: state.tiers.customerSearch,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        customerSearch: (code, user) => dispatch(customerSearch(code, user)),
        clearCustomerSearch: () => dispatch(clearCustomerSearch()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DetailsTab);
